import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AlertService,
  AuthenticationService,
  ShadowService,
} from 'src/app/shared/_services';
import {
  CountdownEvent,
  CountdownConfig,
  CountdownComponent,
} from 'ngx-countdown';
import { DashboardStore, LoginStore, SignupStore } from 'src/app/shared/_services/store';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.page.html',
  styleUrls: ['./verify-email.page.scss'],
  providers: [CountdownComponent],
})
export class VerifyEmailPage implements OnInit {
  @ViewChild(CountdownComponent, { static: false }) counter: CountdownComponent;
  email = this.signupStore.getEmail();
  loginEmail = this.loginStore.getLoginEmail();
  success: string;
  disabled = true;
  hidden = true;
  timer: CountdownConfig;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loginStore: LoginStore,
    private signupStore: SignupStore,
    private alertService: AlertService,
    private auth: AuthenticationService,
    private dashboardStore: DashboardStore,
    private shadowService: ShadowService
  ) {
    this.timer = { leftTime: 240, format: 'mm:ss' };
  }

  onCodeChanged(code: any) {
    console.log(code);
  }

  onCodeCompleted(code: any) {
    console.log(code);
    this.alertService.loading('Verifying your email');
    this.auth.verifyEmail(code.toLowerCase()).subscribe(
      (response) => {
        console.log(response);
        this.alertService.stopLoading();
        this.alertService.retry(
          'Account Activated Succesfully! <br/> Taking you to your Dashboard',
          3000,
          true
        );
        this.dashboardStore.setCurrentUser(response);
        setTimeout(() => {
          this.router.navigateByUrl('/dashboard');
        }, 3000);
      },
      (error) => {
        console.error(error);
        this.alertService.stopLoading();
        this.alertService.retry(error.error.message, 5000, true);
      }
    );
  }

  getNewCode() {
    this.auth.getNewCode(this.email || this.loginEmail).subscribe(
      (response) => {
        console.log(response);
        this.alertService.standardAlertNullDuration(
          'Code sent! <br/> Please check your email'
        );
      },
      (error) => {
        this.alertService.standardAlertNullDuration(
          'Cannot generate new code. Please try again'
        );
        console.log(error);
      }
    );
    this.disabled = !this.disabled;
    this.counter.restart();
  }

  resetTimer(ev: CountdownEvent) {
    if (ev.action === 'done') {
      this.counter.stop();
      this.disabled = !this.disabled;
      this.hidden = false;
    }
  }

  goBack() {
    this.router.navigateByUrl('/login');
  }

  ionViewWillEnter() {
    document.title = 'Verify Email | Bank3D';
    this.shadowService.button();
  }

  ngOnInit() {
    const isRegistered = 'registered';
    if (this.route.snapshot.queryParams[isRegistered]) {
      this.success = 'Sign Up Successful!';
    }
  }
}
